import React, {useState, useEffect, useContext} from 'react';
import RoomService from "../../service/RoomService";
import ErrorComponent from '../UI/Error/ErrorComponent';
import Succses from "../UI/Notification/Succses"
import {useNavigate} from "react-router-dom";
import telegramPhoto from "./img.png"
import "./Timer.css"
import {NAME_HOST_GAME} from "../../Utils/NAME_HOST";
import {Context} from "../../index";
import {observer} from "mobx-react-lite";

const Timer = ({ initialTime,initialTimeReg,isReg}) => {

    const {store} = useContext(Context)
    const data_texts = store.dataLang
    const [timeRemaining, setTimeRemaining] = useState(3600+initialTime);
    const [timeRemainingReg , setTimeRemainingReg] = useState(3600+initialTimeReg);
    const [error, setError] = useState("");
    const [statusErrorChange,setStatusErrorChange] = useState(false);

    const navigate = useNavigate();


    useEffect(() => {

        if (error.length>0){
            store.add_message(error,ErrorComponent)
        }
    }, [statusErrorChange]);

    useEffect(() => {
        const timerInterval = setInterval(() => {
            setTimeRemaining(prevTime => prevTime - 1);
            setTimeRemainingReg(prevTime=>prevTime-1)
        }, 1000);

        return () => clearInterval(timerInterval);
    }, []);
    async function enter_tour(){
        const message = await RoomService.go_tour();
        if (message.data.message === "ok"){
            window.location.replace(NAME_HOST_GAME+"/game")

            window.location.replace(NAME_HOST_GAME+"/game")

        }
        if(message.data.message==="not_found_user"){
            navigate("")
        }
        if (message.data.message==="not_reg"){
            setStatusErrorChange(!statusErrorChange)
            setError("error24")
        }


    }

    async function reg_tour() {
        const message = await RoomService.enter_tour();
        if (message.data.message === "ok"){


            // setMessageSuccses("Вы успешно зарегестрировались")
            window.location.reload();
        }
        if(message.data.message==="online_maxs"){
            setStatusErrorChange(!statusErrorChange)

            setError("error23")
        }
        if(message.data.message==="not_found_user"){
            navigate("")
        }
    }

    const formatTime = (time) => {
        const hours = Math.floor(time / 3600);
        const minutes = Math.floor((time % 3600) / 60);
        const seconds = time % 60;

        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    // if (timeRemaining<-3600){
    //     return (<div>
    //         <h1>Ждите завтрашнего дня</h1>
    //     </div>)
    // }
    // console.log(timeRemaining , timeRemainingReg , isReg)
    if (timeRemaining>=3600*2){
        return (
            <div className="contTimer">
                <p>14:00 - 22:00 {data_texts["msk_time"]}</p>
                <p>{data_texts["text_inf_tour1"]}</p><br/>

                <p style={{color:"greenyellow"}}>{data_texts["text_inf_tour2"]}</p><br/>
                <p>{data_texts["text_inf_tour3"]}</p>
                <a target="_blank" href="https://t.me/+khJTTzu2-qc5NTE8"><img className="icoTg" width={40} height={40} src={telegramPhoto} alt=""/></a>

            </div>
        )
    }

    if (timeRemaining<-600||(timeRemainingReg<0 && !isReg)){
        setTimeRemaining(timeRemaining+86400)
        setTimeRemainingReg(timeRemainingReg+86400)


    }

    if (timeRemaining>0 && timeRemaining<3600*2) {
        return (
            <div className="contTimer">
                <h2>{data_texts["text_inf_tour4"]}</h2>
                <p className="time">{formatTime(timeRemaining)}</p>
            </div>
        );
    }
    if (timeRemainingReg>0){
        return (
            <>
                {(<div className="contTimer">
                    {!isReg?<button onClick={reg_tour} className="btn_reg_tour">{data_texts["reg_name"]}</button>:<h1>{data_texts["succses_register_name"]}</h1>}
                    <h1>{data_texts["text_inf_tour5"]}</h1>
                    {/*<button onClick={enter_tour} className="btn_reg_tour">Войти</button>*/}

                    <p className="timeReg">{formatTime(timeRemainingReg)}</p>

                </div>)}
            </>
        )
    }

    if(timeRemainingReg<0&&isReg){
        return (
            <>
                {(<div className="contTimer">

                    <button onClick={enter_tour} className="btn_reg_tour">{data_texts["enter_name"]}</button>
                </div>)}
            </>

        )
    }







};

export default observer(Timer);